import React from 'react';
import { PropTypes } from 'prop-types';

const ScrollArrowIcon = () => (
  <svg width="20" height="20">
    <g>
      <rect fill="none" id="canvas_background" height="22" width="22" y="-1" x="-1" />
      <g display="none" overflow="visible" y="0" x="0" height="100%" width="100%" id="canvasGrid">
        <rect fill="url(#gridpattern)" strokeWidth="0" y="0" x="0" height="100%" width="100%" />
      </g>
    </g>
    <g>
      <line id="svg_49" y2="13.704918" x2="9.229695" y1="6.281949" x1="16.932776" strokeWidth="3" stroke="#000" fill="none" />
      <line stroke="#000" id="svg_50" y2="13.424806" x2="11.050423" y1="6.422006" x1="3.347343" strokeWidth="3" fill="none" />
    </g>
  </svg>
);

const ScrollButton = ({ unreadMessages, onClick }) => (
  <div onClick={onClick} className="message-display-area__wrapper__scroll-btn">
    { !!unreadMessages && unreadMessages !== 0 && (
      <div className="message-display-area__wrapper__scroll-btn__count">
        <span>{unreadMessages}</span>
      </div>
    )}
    <ScrollArrowIcon />
  </div>
)

ScrollButton.propTypes = {
  unreadMessages: PropTypes.number,
  onClick: PropTypes.func,
}

export default ScrollButton;
